import React from 'react';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from './VinovestExchange.module.scss';
import classNames from 'classnames';
import { LinkWithLayers } from '~/vinovest-design-system/components/LinkWithLayers';

export const VinovestExchange = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <div className={styles.exchange} ref={ref}>
            <p className={classNames(runAnimation, 'heading-desc')}>Vinovest Marketplace </p>
            <h1 className={classNames(runAnimation, 'heading-2')}>Invest in Wine You Want, When You Want</h1>
            <p className={runAnimation}>
                The Vinovest Marketplace lets you invest in wine the same way you invest in stocks. No minimum balance.
                No hold time. Just 100% control.
            </p>
            <LinkWithLayers theme={'black'} className={styles.button} href={'/trade/marketplace'}>
                Try now
            </LinkWithLayers>
        </div>
    );
};
